module.exports = __webpack_public_path__ + "img/53.06ccf6cf.jpg";